import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'primereact/button';
export const BotonGuardar = (props) => {
const { errores ,usuario, setUsuarios  } = props;
    
    const guardar = () =>{
        console.log(usuario);
}

   

    return (
    <div>
       
       <Button type="button" onClick={() => guardar()} label="guardar" />
        </div>
    )
}
